// extracted by mini-css-extract-plugin
module.exports =  {"modal":"trtlRuRy_lcLwLkR6cUT","body":"bL2btykhNKmmn3vXvUGh","previewArea":"MAn46FK7KFYvu_tQYWjb","sidebar":"MJ1cI3I0WKMaw6XIMjA3"};